import { useState } from 'preact/hooks';
import { BRAND } from '../brand';
import { SearchBox } from './SearchBox';
import { BodySwitch } from './BodySwitch';
import { surprise } from '../search/search';
import * as st from '../state/store';
import { track } from '../analytics';

export function TopBar({ onHelp }: { onHelp: () => void }) {
  const [menu, setMenu] = useState(false);
  const goSurprise = () => {
    let s = surprise(st.selected.value?.id);
    const unsuitable = (x: typeof s) => !!x && ((st.sensitiveHidden() && x.sensitive) || (!!x.body && x.body !== st.body.value));
    for (let i = 0; i < 30 && unsuitable(s); i++) s = surprise(st.selected.value?.id);
    if (s) {
      st.select(s.id);
      track('card_open', { structure_id: s.id, source: 'surprise' });
    }
  };
  return (
    <header class="topbar" data-testid="topbar">
      <a class="brand" href="/" aria-label={`${BRAND.name} home`}>
        <img src="/icon.svg" alt="" width="28" height="28" />
        <span class="brand-name" data-testid="brand-name">{BRAND.name}</span>
      </a>
      {!st.classroom.value && <SearchBox />}
      <nav class="top-actions" aria-label="Main">
        <BodySwitch />
        <button type="button" class="btn ghost" onClick={() => (st.panel.value = st.panel.value === 'tours' ? null : 'tours')} data-testid="tours-button">
          Tours
        </button>
        <button type="button" class="btn ghost hide-narrow" onClick={goSurprise} data-testid="surprise-button">
          Surprise me
        </button>
        <button type="button" class="btn ghost hide-narrow" onClick={() => (st.exportOpen.value = true)} data-testid="export-button">
          Save image
        </button>
        <div class="menu-wrap">
          <button type="button" class="btn ghost icon" aria-haspopup="menu" aria-expanded={menu} aria-label="Menu" onClick={() => setMenu(!menu)} data-testid="menu-button">
            ☰
          </button>
          {menu && (
            <ul class="menu" role="menu" onClick={() => setMenu(false)}>
              <li role="none" class="show-narrow"><button role="menuitem" type="button" onClick={goSurprise}>Surprise me</button></li>
              <li role="none" class="show-narrow"><button role="menuitem" type="button" onClick={() => (st.exportOpen.value = true)}>Save image</button></li>
              <li role="none"><button role="menuitem" type="button" onClick={() => (st.panel.value = 'browse')} data-testid="browse-button">Browse all parts</button></li>
              <li role="none"><button role="menuitem" type="button" onClick={() => (st.offlineOpen.value = true)} data-testid="offline-button">Use offline</button></li>
              <li role="none"><button role="menuitem" type="button" onClick={() => st.toggleClassroom()} data-testid="classroom-toggle">{st.classroom.value ? 'Exit classroom mode' : 'Classroom mode'}</button></li>
              {st.classroom.value && (
                <li role="none">
                  <button role="menuitemcheckbox" aria-checked={st.showSensitive.value} type="button" onClick={() => (st.showSensitive.value = !st.showSensitive.value)} data-testid="sensitive-toggle">
                    {st.showSensitive.value ? 'Hide sensitive parts' : 'Show sensitive parts'}
                  </button>
                </li>
              )}
              <li role="none"><button role="menuitem" type="button" onClick={onHelp}>Help & shortcuts</button></li>
              <li role="none"><button role="menuitem" type="button" onClick={() => (st.panel.value = 'unlock')} data-testid="support-button">Support {BRAND.name}</button></li>
              <li role="none"><a role="menuitem" href="/teachers/">For teachers</a></li>
              <li role="none"><a role="menuitem" href="/about/">About</a></li>
              <li role="none"><a role="menuitem" href="/credits/">Credits & licences</a></li>
              <li role="none"><a role="menuitem" href="/privacy/">Privacy</a></li>
            </ul>
          )}
        </div>
      </nav>
    </header>
  );
}
